import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useState } from "react";


import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';




const RequestIndentActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess }) => {

    const [selectedButton, setSelectedButton] = useState(null);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
    };
    return (

        <Grid container display="flex-start" padding={0}>

         
            {/* <Grid item md={0} ml="1px" mr="1px">
                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Email')}>
                            <EmailOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'ParentRolls' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Send Mail</Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

       
            <Grid item md={0} ml="5px" mr="5px">

                <Tooltip title="Add new orders">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('PDF')}>
                            <PictureAsPdfOutlinedIcon style={{ fontSize: "18px", color: selectedButton === 'PDF' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>PDF/Print</Typography>
                        </IconButton>

                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} /> */}

            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Approve request">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Approve request')}>
                            <ExitToAppRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'Receive' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Approve Indent</Typography>
                        </IconButton>

                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

            {/* Add Button */}
            <Grid item md={0} ml="5px" mr="5px">
                <Tooltip title="Amend Request">
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <IconButton onClick={() => handleButtonClick('Ament')}>
                            <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'Bundles' ? "yellow" : "#009688" }} />
                            <Typography variant="h6" sx={{ marginLeft: "5px" }}>Amend Request</Typography>
                        </IconButton>
                    </div>
                </Tooltip>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />


        </Grid>



    )
};
export default RequestIndentActionMenu;